// App.jsx
import './App.css';
import Navbar from './components/navbar';
import Homepage from './components/HomePage';
import Footer from './components/footer';
import About from './components/about';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Academics from './components/academics';
import Admissions from './components/admissions';
import Events from './components/events';
// import Primary from './components/primarylevel';
import StudentLife from './components/studentlife';
import AdmissionForm from './components/Admisssionsform';
import AcademicPrograms from './components/rankridgegrades';
import WhatsApp from './components/WhatsApp';
import CallButton from './components/callbuttons';
import StateBoard from './components/StateBoard';
import PrePrimary from './components/pre_primary';
import PrimarySchool from './components/Primary';
import Secondary from './components/secondary';
import CbseSchool from './components/School';
import SchoolIIT_JEE from './components/SchoolIIT-JEE';
import BlogList from './components/BlogList';
import BlogPost from './components/BlogPost';
// import EnquiriesList from './components/enquirieslist';
import { HelmetProvider } from 'react-helmet-async';

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <Navbar />
          {/* Global floating actions */}
          <WhatsApp />
          <CallButton />

          <Routes>
            <Route path="/" element={<Homepage />} />
            <Route path="/about-us" element={<About />} />
            <Route path="/academics" element={<AcademicPrograms metaStatus={true} status={false} />} />
            <Route path="/admissions" element={<Admissions />} />
            <Route path="/events" element={<Events />} />
            {/* <Route path="/primary" element={<Primary />} /> */}
            <Route path="/student-life" element={<StudentLife />} />
            <Route
              path="/form"
              element={
                <AdmissionForm classData="w-full ms-0 me-0 grid grid-cols-1 sm:grid-cols-1 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-3" />
              }
            />
            <Route path="/blog" element={<BlogList />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            {/* <Route path="/enquiries-list" element={<EnquiriesList />} /> */}

            <Route path="/state-board-education" element={<StateBoard />} />
            <Route path="/pre-primary-education" element={<PrePrimary />} />
            <Route path="/primary-school-education" element={<PrimarySchool />} />
            <Route path="/middle-secondary-education" element={<Secondary />} />
            <Route path="/best-cbse-schools-in-hyderabad" element={<CbseSchool />} />
            <Route path="/top-iit-jee-neet-foundation" element={<SchoolIIT_JEE />} />

            {/* Fallback */}
            <Route path="*" element={<Homepage />} />
          </Routes>

          <Footer />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
